<div class="big-wrapper">
    <div class="main-container">
        <ng-container *ngFor="let button of buttons">
            <div
                *ngIf="button.condition"
                class="button-wrapper"
                (click)="handleClick(button)"
                [matBadgeHidden]="!button.badgeData"
                [matBadge]="button.badgeData?.count"
                [matBadgeColor]="button.badgeData?.isWarn ? 'warn' : 'primary'"
                [matTooltip]="button.tooltip ? button.tooltip : undefined">
                <div class="card-layer card-layer--back1"></div>
                <div class="card-layer card-layer--back2"></div>
                <div class="icon-wrapper">
                    <div class="icon-stack">
                        <mat-icon class="icon-layer icon-layer--back1" [svgIcon]="button.iconName"></mat-icon>
                        <mat-icon class="icon-layer icon-layer--back2" [svgIcon]="button.iconName"></mat-icon>
                        <mat-icon class="button-icon" [svgIcon]="button.iconName"></mat-icon>
                    </div>
                    <div class="sub-actions" *ngIf="button.subActions?.length" (click)="$event.stopPropagation()">
                        <button mat-mini-fab
                            *ngFor="let action of button.subActions"
                            class="sub-action-btn"
                            [matTooltip]="action.tooltip | translate"
                            (click)="action.onClick()">
                            <mat-icon [svgIcon]="action.icon"></mat-icon>
                        </button>
                    </div>
                </div>
                <div class="button-text-background">
                    <div class="button-text"
                        [ngClass]=" { 'long-text' : (button.text | translate).length>= 15, 'very-long-text': (button.text | translate).length >= 25 }">
                        {{ button.text | translate | capitalizeFirst }}
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>